import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import { AuthEntity } from './auth.models';
import {AuthError, Role, User, UserPermissions} from "../auth-http.interface";
import {AuthenticationActions, UserActions, UserPermissionActions} from "./auth.actions";

export const AUTH_FEATURE_KEY = 'auth';

export interface AuthState extends EntityState<AuthEntity> {
  user: User | null;
  role: Role | null;
  token: string | null;
  permissions: UserPermissions | null;
  selectedId?: string | number; // which Auth record has been selected
  loaded: boolean; // has the Auth list been loaded
  error?: AuthError | null; // last known error (if any)
}

export interface AuthPartialState {
  readonly [AUTH_FEATURE_KEY]: AuthState;
}

export const authAdapter: EntityAdapter<AuthEntity> =
  createEntityAdapter<AuthEntity>();

export const initialAuthState: AuthState = authAdapter.getInitialState({
  user: null,
  role: null,
  token: null,
  permissions: null,
  loaded: false,
  error: null
});

const reducer = createReducer(
  initialAuthState,
  on(AuthenticationActions.signIn, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(AuthenticationActions.signInSuccess, (state, { token, user }) => ({
    ...state,
    user,
    token,
    loaded: true,
    error: null,
  })),
  on(AuthenticationActions.signInFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  })),
  on(UserActions.getUserSuccess, (state, { user }) => ({
    ...state,
    user,
    role: user.role,
  })),
  on(UserActions.getUserFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(UserPermissionActions.getPermissions, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(UserPermissionActions.getPermissionsSuccess, (state, { permissions }) => ({
    ...state,
    permissions,
    loaded: true,
    error: null,
  })),
  on(UserPermissionActions.getPermissionsFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  }))
);

export function authReducer(state: AuthState | undefined, action: Action) {
  return reducer(state, action);
}
